<div class="inner-content">
  <nz-breadcrumb>
    <nz-breadcrumb-item>首页</nz-breadcrumb-item>
    <nz-breadcrumb-item>上传列表</nz-breadcrumb-item>
  </nz-breadcrumb>
  <div class="search-box">
    <div nz-row [nzGutter]="0">
      <div nz-col nzFlex="280px">
        <div nz-row>
          <div nz-col class="label" nzFlex="80px">患者姓名</div>
          <div nz-col nzFlex="1">
            <input nz-input placeholder="患者姓名" [(ngModel)]="searchParams.patientName" />
          </div>
        </div>
      </div>
      <div nz-col nzFlex="350px">
        <div nz-row>
          <div nz-col class="label" nzFlex="100px">上传时间</div>
          <div nz-col nzFlex="248px">
            <nz-range-picker [(ngModel)]="searchParams.date" style="border-radius: 8px"></nz-range-picker>
          </div>
          <!-- <div nz-col class="quick-choose" nzFlex="180px">
            <nz-radio-group nzButtonStyle="solid" [(ngModel)]="quickDateType">
              <label nz-radio-button nzValue="today">当日</label>
              <label nz-radio-button nzValue="month">本月</label>
              <label nz-radio-button nzValue="year">全年</label>
            </nz-radio-group>
          </div> -->
        </div>
      </div>
      <div nz-col nzFlex="280px">
        <div nz-row>
          <div nz-col class="label" nzFlex="100px">设备类型</div>
          <div nz-col nzFlex="auto">
            <!-- deviceList select -->
            <nz-select [(ngModel)]="searchParams.deviceTypes" nzShowSearch nzPlaceHolder="请选择设备类型" nzMode="multiple" style="width: 100%">
              <nz-option *ngFor="let item of deviceList" [nzLabel]="item.label" [nzValue]="item.value"></nz-option>
            </nz-select>
          </div>
        </div>
      </div>
      <div nz-col nzFlex="140px" style="text-align: right">
        <button nz-button nzType="primary" (click)="search()">搜索</button>
        <button nz-button nzType="default" (click)="reset()">重置</button>
      </div>
      <div nz-col nzFlex="1"></div>
    </div>
  </div>
  <div class="main-container">
    <div class="table-container">
      <div class="search-group">
        <div class="item-list">
          <div class="item" [ngClass]="selectedGroup.id === '' ? 'active' : ''" (click)="selectedGroup = { id: '' }; search()">全部</div>
          <div class="item" [ngClass]="selectedGroup.id === item.id ? 'active' : ''" *ngFor="let item of searchGroups">
            <span (click)="selectedGroup = item; search()">{{ item.name }}</span>
            <!-- 编辑 -->
            <i nz-icon nzType="edit" (click)="editGroup(item)" style="font-size: 12px; margin-left: 5px"></i>
          </div>
          <!-- 新增 -->
          <div class="item" (click)="addGroup()">
            <i nz-icon nzType="plus"></i>
          </div>
        </div>
      </div>
      <nz-table #basicTable [nzData]="dataList" [nzTotal]="total" [nzBordered]="false" [nzSize]="'middle'" [nzShowSizeChanger]="true" [nzShowQuickJumper]="true" [nzFrontPagination]="false" [nzShowPagination]="true" [nzPageSize]="searchParams.pageSize" [nzPageIndex]="searchParams.pageIndex" (nzPageIndexChange)="pageIndexChange($event)" (nzPageSizeChange)="pageSizeChange($event)" [nzScroll]="{ x: '1150px' }">
        <thead>
          <tr>
            <th nzWidth="100px" [nzAlign]="'center'">状态</th>
            <th nzWidth="100px" [nzAlign]="'center'">病例号</th>
            <th nzWidth="150px" [nzAlign]="'center'">姓名</th>
            <th nzWidth="100px" [nzAlign]="'center'">性别</th>
            <th nzWidth="100px" [nzAlign]="'center'">年龄</th>
            <th nzMinWidth="150px" [nzAlign]="'center'">设备类型</th>
            <th nzMinWidth="150px" [nzAlign]="'center'">检查部位</th>
            <th [nzAlign]="'center'">上传时间</th>
            <th [nzAlign]="'center'">检查时间</th>
            <th nzWidth="240px" [nzAlign]="'center'" nzRight>操作</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let item of basicTable.data">
            <td [nzAlign]="'center'">
              <span [ngClass]="getStatusClass(status[item.status])">
                {{ status[item.status] }}
              </span>
            </td>
            <td [nzAlign]="'center'">{{ item.checkSerialNum }}</td>
            <td [nzAlign]="'center'">{{ item.patientName }}</td>
            <td [nzAlign]="'center'">{{ formatGender(item.patientGender) }}</td>
            <td [nzAlign]="'center'">{{ item.patientAge }}</td>
            <td [nzAlign]="'center'">{{ item.deviceType }}</td>
            <td [nzAlign]="'center'">{{ item.bodyPartExamined }}</td>
            <td [nzAlign]="'center'">{{ formatTime(item.uploadTime) }}</td>
            <td [nzAlign]="'center'">{{ formatTime(item.studyTime) }}</td>
            <td [nzAlign]="'center'" nzRight>
              <nz-button-group>
                <!-- <button nz-button nzType="default" (click)="showQrCode(item)">
                  <span nz-icon nzType="link" nzTheme="outline" style="color: #b54f41" *ngIf="item.boundMedicalCardId"></span>
                  二维码
                </button> -->
                <button nz-button nzType="default" disabled="{{ status[item.status] !== '已报告' }}" [routerLink]="['/admin/report/print', item.id]"><span nz-icon nzType="link" nzTheme="outline" style="color: #b54f41" *ngIf="item.boundMedicalCardId"></span>打印报告</button>
                <button nz-button nzType="default" (click)="replenishCase(item)">补录</button>
                <!-- <button nz-button nzType="primary" [routerLink]="['/admin/case/detail', item.id]">诊断</button> -->
              </nz-button-group>
            </td>
          </tr>
        </tbody>
      </nz-table>
    </div>
    <div class="replenish-container" [ngClass]="showReplenish ? 'show' : 'hide'">
      <div class="replenish-box">
        <div class="replenish-title">
          <div class="t">补录病例（{{ replenishCaseForm.checkSerialNum }}）</div>
          <div class="action" (click)="showReplenish = false; replenishCaseForm = {}">
            <span nz-icon nzType="close" nzTheme="outline"></span>
          </div>
        </div>
        <div class="replenish-form">
          <div class="form-item">
            <div class="label">姓名<span class="required">*</span></div>
            <div class="input">
              <input nz-input [(ngModel)]="replenishCaseForm.patientName" style="width: 120px" />
            </div>
          </div>
          <div class="form-item">
            <div class="label">年龄<span class="required">*</span></div>
            <div class="input">
              <input nz-input [(ngModel)]="replenishCaseForm.patientAge" style="width: 100px" />
            </div>
          </div>
          <div class="form-item">
            <div class="label">性别<span class="required">*</span></div>
            <div class="input">
              <nz-radio-group [(ngModel)]="replenishCaseForm.patientGender" nzButtonStyle="solid">
                <label nz-radio-button [nzValue]="'1'">男</label>
                <label nz-radio-button [nzValue]="'2'">女</label>
              </nz-radio-group>
            </div>
          </div>
          <!-- 检查类型 -->
          <div class="form-item">
            <div class="label">检查类型<span class="required">*</span></div>
            <div class="input">
              <nz-select [(ngModel)]="replenishCaseForm.examinationType" nzShowSearch nzPlaceHolder="请选择检查类型" style="width: 100%">
                <nz-option *ngFor="let item of examinationTypeList" [nzLabel]="item.label" [nzValue]="item.value"></nz-option>
              </nz-select>
            </div>
          </div>
          <!-- 患者手机号 -->
          <div class="form-item">
            <div class="label">患者手机号<span class="required">*</span></div>
            <div class="input">
              <input nz-input [(ngModel)]="replenishCaseForm.patientPhone" />
            </div>
          </div>
          <!-- 患者身份证号 -->
          <div class="form-item">
            <div class="label">患者身份证号<span class="required">*</span></div>
            <div class="input">
              <input nz-input [(ngModel)]="replenishCaseForm.patientIdCard" />
            </div>
          </div>
          <div class="form-item">
            <div class="label">检查部位<span class="required">*</span></div>
            <div class="input">
              <input nz-input [(ngModel)]="replenishCaseForm.bodyPartExamined" />
            </div>
          </div>
          <!-- 扫描方式 -->
          <div class="form-item">
            <div class="label">扫描方式</div>
            <div class="input">
              <nz-select [(ngModel)]="replenishCaseForm.scanMethod" nzShowSearch nzPlaceHolder="请选择扫描方式" style="width: 100%">
                <nz-option *ngFor="let item of scanMethodList" [nzLabel]="item.label" [nzValue]="item.value"></nz-option>
              </nz-select>
            </div>
          </div>
          <!-- 临床医嘱 -->
          <div class="form-item">
            <div class="label">临床医嘱<span class="required">*</span></div>
            <div class="input">
              <textarea nz-input [(ngModel)]="replenishCaseForm.clinicalAdvice" [rows]="4" style="width: 100%"></textarea>
            </div>
          </div>
          <div class="btns">
            <button nz-button nzType="primary" (click)="submitReplenish()">提交</button>
            <button nz-button nzType="default" (click)="showReplenish = false; replenishCaseForm = {}">取消</button>
          </div>
        </div>
      </div>
    </div>
    <nz-modal [(nzVisible)]="isVisibleQrCode" nzTitle="数字胶片小程序二维码" nzCentered (nzOnCancel)="handleCancelMiddle()" nzWidth="320" (nzOnOk)="handleOkMiddle()">
      <ng-container *nzModalContent>
        <div style="text-align: center">
          <img [src]="qcCodeURL" alt="" />
        </div>
      </ng-container>
    </nz-modal>
  </div>
</div>
<ng-template #searchGroupDrawerFooter>
  <div class="footer-buttons">
    <button nz-button nzType="default" (click)="deleteGroup()">删除</button>
    <button nz-button nzType="primary" (click)="onSubmitSearchGroup()">保存</button>
    <button nz-button nzType="default" (click)="onCancelSearchGroup()">取消</button>
  </div>
</ng-template>
